module.exports = __webpack_public_path__ + "img/5.739f52a2.png";